module.exports = __webpack_public_path__ + "static/media/biglietti-bg.4d3ec495.jpg";